import React, { useId } from 'react';

const RuStoreIcon = ({ size = 89 }) => {
  const maskId = useId();
  const fill = 'var(--icon-color, #3EAB36)';
  const accent = 'var(--icon-accent, #ffffff)';

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 88 88"
      fill="none"
    >
      <defs>
        <mask id={maskId} maskUnits="userSpaceOnUse" x="0" y="0" width="88" height="88">
          <path
            d="m42.2 88c-19.9 0-29.9 0-36.1-6.19-6.19-6.19-6.19-16.1-6.19-36.1l-1.6e-7 -3.52c-8.7e-7 -19.9-1.32e-6 -29.9 6.19-36.1 6.19-6.19 16.1-6.19 36.1-6.19h1e-4l3.52-1.5e-7c19.9-8.7e-7 29.9-1.29e-6 36.1 6.19 6.19 6.19 6.19 16.1 6.19 36.1v3.52c0 19.9 0 29.9-6.19 36.1s-16.1 6.19-36.1 6.19z"
            fill="#fff"
          />
          <path
            d="m51.2 16.1c-2.3-0.0226-4.3 1.83-4.3 4.25v5.17l-10.8-2.69c-0.336-0.0838-0.671-0.126-1-0.129-2.3-0.0226-4.3 1.83-4.3 4.25v5.15l-10.7-2.67c-2.69-0.67-5.3 1.36-5.3 4.12v28.7c0 2.44 1.66 4.56 4.03 5.15l17.1 4.26c2.69 0.67 5.3-1.36 5.3-4.12v-28.7c0-1.75-0.857-3.33-2.21-4.3-0.0216-0.0707-0.0167-0.149 0.0273-0.213 0.075-0.109 0.21-0.161 0.336-0.123 2.25 0.68 4.39 2.98 4.61 5.88l0.742 21.9c0.0191 0.734 0.509 1.36 1.2 1.59l6 1.49c2.69 0.67 5.3-1.36 5.3-4.12 0.0708-9.47 0.0504-19.1 0.0528-28.6 0-1.29-0.436-2.28-0.926-3-0.0794-0.12-0.163-0.238-0.252-0.352-0.107-0.136-0.224-0.265-0.344-0.391-0.179-0.188-0.37-0.367-0.576-0.527-0.0014-0.0011-0.0025-0.0028-0.0039-0.0039-0.0848-0.0852-0.109-0.218-0.0391-0.318 0.075-0.109 0.21-0.161 0.336-0.123 2.25 0.68 4.4 2.98 4.61 5.88l0.742 21.9c0.019 0.728 0.504 1.35 1.19 1.57l6.01 1.5c2.69 0.67 5.3-1.36 5.3-4.12v-28.7c0-2.44-1.66-4.56-4.03-5.15l-17.1-4.26c-0.336-0.0838-0.671-0.126-1-0.129z"
            fill="#000"
          />
        </mask>
      </defs>
      <path
        style={{ transition: '0.7s ease-in-out' }}
        d="m42.2 88c-19.9 0-29.9 0-36.1-6.19-6.19-6.19-6.19-16.1-6.19-36.1l-1.6e-7 -3.52c-8.7e-7 -19.9-1.32e-6 -29.9 6.19-36.1 6.19-6.19 16.1-6.19 36.1-6.19h1e-4l3.52-1.5e-7c19.9-8.7e-7 29.9-1.29e-6 36.1 6.19 6.19 6.19 6.19 16.1 6.19 36.1v3.52c0 19.9 0 29.9-6.19 36.1s-16.1 6.19-36.1 6.19z"
        fill={accent}
      />
      <path
        style={{ transition: '0.7s ease-in-out' }}
        d="m42.2 88c-19.9 0-29.9 0-36.1-6.19-6.19-6.19-6.19-16.1-6.19-36.1l-1.6e-7 -3.52c-8.7e-7 -19.9-1.32e-6 -29.9 6.19-36.1 6.19-6.19 16.1-6.19 36.1-6.19h1e-4l3.52-1.5e-7c19.9-8.7e-7 29.9-1.29e-6 36.1 6.19 6.19 6.19 6.19 16.1 6.19 36.1v3.52c0 19.9 0 29.9-6.19 36.1s-16.1 6.19-36.1 6.19z"
        fill={fill}
        mask={`url(#${maskId})`}
      />
    </svg>
  );
};

export default RuStoreIcon;
